import React from "react";

export const ArrowNext: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.801 16">
    <g transform="translate(8.801 16) rotate(180)">
      <path
        d="M.234,14.634a.8.8,0,0,0,1.131,1.131l7.2-7.2a.8.8,0,0,0,0-1.131l-7.2-7.2A.8.8,0,0,0,.234,1.366L6.869,8Z"
        transform="translate(8.8 16) rotate(180)"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
